import { connect } from 'react-redux'
import propertyCalculationButton from '../ui/buttons/propertyCalculationButton'
import { setPropertyTablesAction, clearPropertyTablesAction } from '../../store/actions/propertyTableActions'

const mapStateToProps = state => ({
    values: state.formulas.propertyTable
})

const mapDispatchToProps = dispatch => {
    return {
        valueToState: (val) => {
            dispatch(
                setPropertyTablesAction(val)
            )
        },
        clearValues: () => {
            dispatch(
                clearPropertyTablesAction()
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(propertyCalculationButton)